export class NewLocationGroup{
    constructor(
        public name: String = '',
        public merchantId: String = '',
        public location: Array<any> = Array<any>(),
        public locationGroupId: String = '',
        public cocoOrRoro: String = ''
    ){}
}